import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

import { GeneralError } from '../GeneralError.view.tsx';

const WaitingForApproval = () => {
  const { t } = useTranslationWithPrefix('generalError.waitingForApproval');

  return <GeneralError hideButton message={t('message')} subMessage={t('subMessage')} />;
};

export default WaitingForApproval;
